import React from 'react';
import Card from 'react-bootstrap/Card';
import ShowMoreText from 'react-show-more-text';
import projImg12 from '../../assets/img/12.png';
import projectimage13 from '../../assets/img/p13.png';
let cardClass = "Card3";

const PreviousCard13 = () => {
    return (
        <Card className={cardClass} bg="dark">
        {/* <Card.Title><h2>The impact of the Russia-Ukraine war and the energy crisis on the perception of nuclear energy</h2></Card.Title> */}
        <Card.Img variant="top" src={projectimage13} />

        <Card.Body>
          <Card.Text>
            <img className="img2" src={projImg12} />{" "}
            <p className="text7">Attila Aszódi </p>
            <br />
            <p className="text8">
              Professor, Dean
              <br /> Institute of Nuclear Techniques, BME
            </p>
          </Card.Text>
          <ShowMoreText lines={2}>
            <div>
              The project will be co-supervised by Ildikó Boros. <br />
              In this project, students will analyze articles from news
              outlets, social media posts and memes about nuclear energy
              to investigate how the perception of nuclear energy has
              changed due to the Russia-Ukraine war and the energy crisis.
              Students will use various data science techniques (such as
              topic analysis, sentiment analysis, optical character
              recognition, and object detection) to answer the following
              research questions:
              <br />
              What was the perception of nuclear energy before the war and
              now? Is there a difference between the perception of nuclear
              energy in the press of pro-nuclear and anti-nuclear
              countries? Has it changed due to the war?
              <br /> What factors might play a role?
              <br />
              How is nuclear energy perceived in social media? Has it
              changed as a result of the war?
              <br />
              <br />
              Related literature:{" "}
              <ul>
                <li>
                  McMakin, A. H., & Lundgren, R. E. (2018). Risk
                  communication: A handbook for communicating
                  environmental, safety, and health risks.{" "}
                  <span className="text9">John Wiley & Sons. </span>
                </li>{" "}
                <li>
                  Bird, D. K., Haynes, K., van den Honert, R., McAneney,
                  J., & Poortinga, W. (2014). Nuclear power in Australia:
                  A comparative analysis of public opinion regarding
                  climate change and the Fukushima disaster.
                  <span className="text9"> Energy Policy </span>, 65, 644-653.
                </li>
                <li>
                  Corner, A., Venables, D., Spence, A., Poortinga, W.,
                  Demski, C., & Pidgeon, N. (2011). Nuclear power, climate
                  change and energy security: Exploring British public
                  attitudes. <span className="text9"> Energy Policy </span>,
                  39(9), 4823-4833.
                </li>
                <li>
                  Park, E. (2019). Positive or negative? Public
                  perceptions of nuclear energy in South Korea: Evidence
                  from Big Data.
                  <span className="text9">
                    {" "}
                    Nuclear Engineering and Technology{" "}
                  </span>
                  , 51(2), 626-630.
                </li>
                <li>
                  Khatua, A., Cambria, E., Ho, S. S., & Na, J. C. (2020,
                  July). Deciphering public opinion of nuclear energy on
                  Twitter. In
                  <span className="text9">
                    {" "}
                    2020 International joint Conference on neural networks
                    (IJCNN)
                  </span>{" "}
                  (pp. 1-8). IEEE.
                </li>
                <li>
                  Zarrabeitia-Bilbao, E., Jaca-Madariaga, M., Rio-Belver,
                  R. M., & Álvarez-Meaza, I. (2023). Nuclear energy:
                  Twitter data mining for social listening analysis.
                  <span className="text9">
                    {" "}
                    Social Network Analysis and Mining{" "}
                  </span>
                  , 13(1), 29.
                </li>
                <li>
                  Boumans, J. W., Vliegenthart, R., & Boomgaarden, H. G.
                  (2016). Nuclear voices in the news: A comparison of
                  source, news agency and newspaper content about nuclear
                  energy over time.
                  <span className="text9">
                    {" "}
                    European Journal of Communication{" "}
                  </span>{" "}
                  , 31(3), 260-282.
                </li>
                <li>
                  Mercado-Sáez, M. T., Marco-Crespo, E., & Álvarez-Villa,
                  À. (2019). Exploring news frames, sources and editorial
                  lines on newspaper coverage of nuclear energy in Spain.
                  <span className="text9"> Environmental Communication </span>,
                  13(4), 546-559.
                </li>
              </ul>
            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
}

export default PreviousCard13;
